package horcrux.common.configs

import horcrux.common.GCSBucket
import horcrux.common.api.dtos.types.DocumentChunkSchemaVersion
import horcrux.common.utils.DefaultMap
import horcrux.common.utils.defaultMapOf
import io.ktor.utils.io.charsets.Charset
import io.ktor.utils.io.charsets.Charsets.UTF_8

object DocumentStorageConfigs {
    const val AUTHENTICATED_URL_BASE: String = "https://storage.cloud.google.com"
    const val RAW_DOCUMENTS_BASE_PATH: String = "documents"
    private const val DEFAULT_DOCUMENT_BASE_PATH: String = "documents"
    const val EMBEDDING_BASE_PATH: String = "embeddings"
    const val CHAT_PAGE_DATA_BASE_PATH: String = "chat-page-data"
    const val CHILD_DOCUMENTS_BASE_PATH: String = "child-documents"
    const val GCP_PROJECT_ID: String = "moonraker"
    val DOCUMENT_ENCODING: Charset = UTF_8
    val GCS_BUCKET: GCSBucket = GCSBucket("horcrux")
    val PUBLIC_GCS_BUCKET: GCSBucket = GCSBucket("horcrux-public")
    val REMOTE_CONTENT_CACHE_BUCKET: GCSBucket = GCSBucket("server-app-remote-content-cache")
    val DOCUMENT_BASE_BATH_BY_VERSION: DefaultMap<DocumentChunkSchemaVersion, String> =
        defaultMapOf(
            DocumentChunkSchemaVersion.ZERO to DEFAULT_DOCUMENT_BASE_PATH,
            DocumentChunkSchemaVersion.ONE to "processed-document-chunks/v1"
        ) { DEFAULT_DOCUMENT_BASE_PATH }
}
